import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=af44ab08&scoped=true&"
import script from "./TopNav.vue?vue&type=script&lang=js&"
export * from "./TopNav.vue?vue&type=script&lang=js&"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=af44ab08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af44ab08",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PostponeLogo: require('/Users/grant/Dev/postpone/frontend/components/PostponeLogo.vue').default,PlatformIcon: require('/Users/grant/Dev/postpone/frontend/components/platform/Icon.vue').default,DarkModeToggle: require('/Users/grant/Dev/postpone/frontend/components/DarkModeToggle.vue').default,Announcements: require('/Users/grant/Dev/postpone/frontend/components/Announcements.vue').default})
